var map = {
	"./season_1.json": 35,
	"./season_2.json": 36,
	"./season_3.json": 37,
	"./season_4.json": 38,
	"./season_5.json": 39,
	"./season_6.json": 40,
	"./season_7.json": 41,
	"./season_8.json": 42,
	"./season_9.json": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;